<template>
  <div class="modal-card" :class="$style.container">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ title }}</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>

    <section class="modal-card-body">
      <p v-html="content"></p>
      <br />
      <div v-if="!isActive && endDate" :class="$style.resumeEndDateStyle">
        <b-field label="End Date">
          <b-datepicker
            placeholder="Select a start date"
            icon="calendar-today"
            icon-pack="mdi"
            v-model="endDate"
            class="has-icon-right input-grey datepicker-input"
            :date-formatter="formatDateRange"
          >
          </b-datepicker>
        </b-field>
      </div>
    </section>

    <footer class="modal-card-foot is-borderless">
      <a
        v-if="confirmButton"
        class="button is-link is-text-primary is-borderless"
        type="button"
        @click="updateSettingDataCollection"
      >
        {{ confirmButtonText }}
      </a>

      <button
        v-if="cancelButton"
        class="button is-primary is-rounded"
        @click="
          () => {
            $emit('close');
            $emit('cancel');
          }
        "
      >
        {{ cancelButtonText }}
      </button>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { uniq, cloneDeep as _cloneDeep } from 'lodash';
const dirtyMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({
  components: {},
})
export default class SettingActiveDataCollectionDialog extends Vue {
  @Prop({ default: '' })
  public title!: string;

  @Prop({ default: '' })
  public content!: string;

  @Prop({ default: 'Remove' })
  public confirmButtonText!: string;

  @Prop({ default: true })
  public confirmButton!: boolean;

  @Prop({ default: 'Cancel' })
  public cancelButtonText!: string;

  @Prop({ default: true })
  public cancelButton!: boolean;

  @Prop({ default: true })
  public isActive!: boolean;

  @Prop()
  public resumeEndDate!: Date;

  public endDate: Date = new Date();

  public mounted() {
    this.endDate = _cloneDeep(this.resumeEndDate);
  }

  public getDate(newValue: Date): string {
    return (
      newValue.getDate() +
      ' ' +
      dirtyMonths[newValue.getMonth()] +
      ' ' +
      newValue.getFullYear()
    );
  }

  public updateSettingDataCollection() {
    this.$emit('close');
    this.$emit('confirm', this.endDate);
  }

  public formatDateRange(date: Date): string {
    return this.getDate(date);
  }
}
</script>

<style lang="scss" module>
.container {
  :global(.modal-card-body) {
    overflow: visible;
  }
}
.resumeEndDateStyle {
  width: 50%;
}
</style>
